(function() {
    'use strict';


    AgreementsNarcoticsController.$inject = ['$scope', 'AgreementsWorkflowService'];

    function AgreementsNarcoticsController($scope, AgreementsWorkflowService) {
        var vm = this; //jshint ignore:line
        vm.save = save;
        vm.isSaving = false;

        init();

        function init() {
            if (vm.agreement) {
                if (vm.agreement.dateSigned === null || vm.agreement.dateSigned === undefined) {
                    vm.agreement.dateSigned = new Date(); // default dateSigned is today
                }
            }
        }

        function save() {
            vm.isSaving = true;
            agreementsEmit();
        }

        function agreementsEmit() {
            vm.onChange({agreement: vm.agreement ? vm.agreement : null});
        }

    }

    angular.module('ipmApp').component('agreementsOpioidMonographAndNarcotics', {
        bindings: {
            agreement: '<',
            onChange: '&'
        },
        templateUrl: 'app/agreements-workflow/agreements-narcotics/agreements-narcotics.html',
        controller: AgreementsNarcoticsController,
        controllerAs: 'vm',
        resolve: {
            translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                return $translate.refresh();
            }]
        }
    })
})();
